import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/protected/_layout/delivery-notes/_layout/'
)({
  component: () => null,
});
